import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5528c42cc250001401942d_1783975705367_b9cb38ac/detailreveal_1783965892566/src/app/home/page.tsx");
